<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";
import router from "@/router";

export default {
  name: "OffersShop",
  components: {LoadingPage},

  setup() {

    let store = useStore()
    let orders = store.state.order
    let loading = ref(false)
    let name = ref(useRoute().params.name)
    let offer_id = useRoute().params.offer_id
    let shops = ref([])


    if (orders.offer) {
      store.commit('EmptyBasket')
      store.commit('set_offer', null)
    }

    function offer_shops() {

      loading.value = true
      FreeWorld.Heisenberg({offer_id: offer_id}, 'offer_shops').then((res) => {

        loading.value = false
        shops.value = res.data
        shops.value.forEach((item) => {
          item.selected = false
        })

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, offer_shops)
      })

    }
    offer_shops()

    function check_cart(i) {
      let order = {}

      if (orders.products.length === 0) {

        order.name = name.value
        shops.value.forEach((item, index) => {
          if (index === i) {
            order.pid = item.pid
            order.pic = item.product_pic
            order.shop = {
              number: parseInt(item.count),
              shopname: item.shopname,
              price: parseInt(item.price),
              price_show: parseInt(item.price),
              id: item.shop_id,
            }
            item.selected = true
            return false
          }
        })

        store.commit('set_offer', offer_id)
        store.commit('ProductUpdate', order)
        router.push({name: 'CartPage'})

      } else {

        Swals.Orders('offer').then((res) => {

          if (res.isConfirmed) {
            store.commit('EmptyBasket')

            order.name = name.value
            shops.value.forEach((item, index) => {
              if (index === i) {
                order.pid = item.pid
                order.pic = item.product_pic
                order.shop = {
                  number: parseInt(item.count),
                  shopname: item.shopname,
                  price: parseInt(item.price),
                  price_show: parseInt(item.price),
                  id: item.shop_id,
                }

                item.selected = true
              } else {
                item.selected = false
              }
            })

            store.commit('set_offer', offer_id)
            store.commit('ProductUpdate', order)
            router.push({name: 'CartPage'})

          }

        })


      }

    }


    return {

      name,
      loading,
      shops,
      check_cart,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p dir="rtl" class="font-color font-4 font-bold">{{ name }}</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">

      <div v-if="shops.length !== 0" class="">

        <div v-for="(item , i) in shops" :key="i" class="bg-white rounded-4 p-3 mb-3">

          <div class="d-flex align-items-center justify-content-between">
            <div class="w-75">

              <div class="d-flex align-items-center mb-2">
                <div class="overflow-hidden d-flex align-items-center mx-1">
                  <p class="font-5" :class="{'txtoverflow': item.shopname.length > 25}">{{ item.shopname }}</p>
                </div>

                <img class="icon-size-1" v-if="item.rate == 1" src="../assets/img/rate1.svg" alt="">
                <img class="icon-size-8" v-else-if="item.rate == 2" src="../assets/img/rate2.svg" alt="">
                <img class="icon-size-1" v-else-if="item.rate == 3" src="../assets/img/rate3.svg" alt="">
                <img class="icon-size-8" v-else-if="item.rate == 4" src="../assets/img/rate4.svg" alt="">
                <img class="icon-size-1" v-else-if="item.rate == 5" src="../assets/img/rate5.svg" alt="">
                <img class="icon-size-8" v-else-if="item.rate == 6" src="../assets/img/rate6.svg" alt="">
              </div>

              <div class="d-flex align-items-center mb-2">
                <img class="icon-size-1" src="../assets/img/package2.png" alt="">
                <p class="font-5 mx-2">حجم محصول :</p>
                <p class="font-5 font-color font-bold d-flex align-items-center">
                  <span class="ml-1">{{ item.count }}</span>
                  <span class="">{{ item.unit }}</span>
                </p>
              </div>

              <div class="d-flex align-items-center mb-2">
                <img class="icon-size-1" src="../assets/img/credit2.png" alt="">
                <p class="font-5 mx-2">قیمت محصول :</p>
                <p class="font-5 font-color font-bold d-flex align-items-center">
                  <span class="">{{ parseInt(item.price).toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>

            </div>

            <img class="icon-size-9" src="../assets/img/insurance.svg" alt="">
          </div>

          <div class="div_hr my-3"></div>

          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <img class="icon-size-0-5" src="../assets/img/place_light_color.svg" alt="">
              <p class="font-4 mr-1 text-light-emphasis">{{ item.city }}</p>
            </div>

            <div class="bg-green shadow-custom rounded-pill py-1 px-2 d-flex align-items-center">
              <img class="icon-size-1" src="../assets/img/add-to-cart-withe.svg" alt="">

              <p @click="check_cart(i)" class="font-5 text-white mr-2">افزودن به سبد خرید</p>
            </div>
          </div>

        </div>

      </div>


      <div v-else style="height: 45vh"
           class="animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-end">
        <img src="../assets/img/storee.png" style="width:100px;height: 100px">
        <p class="mt-4 font-4 font-bold" style="white-space: nowrap">فروشگاهی هنوز به پیشنهاد شما پاسخ نداده است</p>
      </div>


    </div>


  </div>

</template>


<style scoped>

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

</style>